import React from 'react';
import { Heading, Text } from '@/components/ui/typography';

function LoginHeader() {
  return (
    <div className="space-y-3 mb-2">
      <Heading level="h1" className="text-4xl font-bold text-foreground tracking-tight">
        Welcome Back
      </Heading>
      <Text size="base" variant="muted" className="text-muted-foreground leading-relaxed">
        Sign in to continue building something amazing with your team.
      </Text>
    </div>
  );
}

export default LoginHeader;